export default __webpack_public_path__ + "static/media/Alphonse_Mucha_Ete_35_x_70_cm.dd66c878.jpg";